export const PAGINATOR_ITEMS_PER_PAGE_COUNT = 25;
export const PAGINATOR_ITEMS_PER_PAGE_OPTIONS = [
  { value: 25, label: 'Show 25' },
  { value: 50, label: 'Show 50' },
  { value: 100, label: 'Show 100' },
  { value: 200, label: 'Show 200' },
];
